type UserFlowHeaderIconProps = {
  imageName: string;
  height: string;
  width: string;
};
const UserFlowHeaderIcon = ({ imageName, height = '136', width = '136' }: UserFlowHeaderIconProps) => (
  <div className="text-align-center paddingBottom-small2">
    <img width={width} height={height} alt="HelloTech User Profile" src={`/_nextassets_/icons/${imageName}.svg`} />
  </div>
);

export default UserFlowHeaderIcon;
